module.exports = __webpack_public_path__ + "static/media/offline.d26f758a.svg";